import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Wrench, ArrowRight } from "lucide-react";
import { CUSTOM_ORDER_PROCESS } from "../../lib/constants";

export function CustomOrdersTeaser() {
  return (
    <section className="py-24 bg-carbon border-y border-amber-500/10" data-testid="custom-orders-teaser-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
          <span className="text-xs font-mono uppercase tracking-[0.25em] text-amber-light">Can't Find It In The Catalog?</span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl uppercase text-white mt-2 mb-5">We Fabricate Custom Parts</h2>
          <p className="text-zinc-400 max-w-md mb-8 leading-relaxed">
            Send us a CAD file, sketch, or your worn original — our engineers reverse-engineer and precision-machine
            replacements for discontinued or one-off components.
          </p>
          <Link
            to="/custom-orders"
            data-testid="custom-orders-teaser-cta"
            className="inline-flex items-center gap-2 bg-amber-light text-obsidian font-semibold px-7 py-3.5 rounded-sm uppercase text-sm tracking-wide hover:bg-white transition-colors duration-300"
          >
            <Wrench className="h-4 w-4" /> Start a Custom Order <ArrowRight className="h-4 w-4" />
          </Link>
        </motion.div>

        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.1 }} className="grid grid-cols-2 gap-4">
          {CUSTOM_ORDER_PROCESS.map((step) => (
            <div key={step.number} className="border border-amber-500/15 rounded-md p-4 bg-obsidian">
              <span className="font-display text-2xl text-amber-500/40">{step.number}</span>
              <p className="text-xs font-bold uppercase tracking-wide text-amber-100 mt-2">{step.title}</p>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
